import API from '../API/ApiURL';
import { axiosNode } from '../config/axiosConfig';
import {
  alertErrorResponse,
  alertSuccessResponse,
} from '../utils/alertResponseHttpUtil';

export default {
  async getUser(id) {
    try {
      const response = await axiosNode.get(`${API.serverUrl}usuario/id/${id}`);
      return response.data;
    } catch (error) {
      alertErrorResponse(error.response.data);
    }
  },

  async actualizar(id, body) {
    try {
      const response = await axiosNode.put(
        `${API.serverUrl}usuario/id/${id}`,
        body
      );
      return alertSuccessResponse(response);
    } catch (error) {
      alertErrorResponse(error.response.data);
    }
  },

  async guardar(body) {
    try {
      const response = await axiosNode.post(`${API.serverUrl}usuario`, body);
      return alertSuccessResponse(response);
    } catch (error) {
      alertErrorResponse(error.response.data);
    }
  },

  async eliminar(id) {
    try {
      const response = await axiosNode.delete(
        `${API.serverUrl}usuario/id/${id}`
      );
      return alertSuccessResponse(response);
    } catch (error) {
      alertErrorResponse(error.response.data);
    }
  },

  async getUsers() {
    try {
      const response = await axiosNode.get(`${API.serverUrl}usuario`);
      return response.data;
    } catch (error) {
      alertErrorResponse(error.response.data);
    }
  },

  async actualizarPerfil(id, body) {
    try {
      const response = await axiosNode.put(
        `${API.serverUrl}usuario/informacion-perfil/id/${id}`,
        body
      );
      return alertSuccessResponse(response);
    } catch (error) {
      alertErrorResponse(error.response.data);
    }
  },
};
